export default function (facebookUrl, instagramUrl) {
    return new Promise((resolve, reject) => {
        fetch(instagramUrl)
            .then(response => response.json())
            .then(instagramData => {

                instagramData = instagramData.map(post => {
                    post.source = 'instagram';
                    post.message_tags = post.content.match(/#[\w]+/g);
                    return post;
                });

                resolve(instagramData);
            })
            .catch(error => {
                console.error('Błąd przy wywoływaniu instagrama:', error);
                reject(error);
            });
    });
}
